import { memo } from 'react';
import MonacoContainer$1 from './MonacoContainer.js';

var MonacoContainer = /*#__PURE__*/memo(MonacoContainer$1);

export default MonacoContainer;
